import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "mixed", "messages", "themeOptions", "initializeMaterial", "onMessage", "logger", "config", "locale", "setLocale", "axiosClient"];
import React, { useMemo } from 'react';
import { IntlProvider } from 'react-intl';
import { UICoreProvider } from '@lumahealthhq/ui-core';
import { ModelProvider } from '@lumahealthhq/ui-model';
import { ELocale } from '@lumahealthhq/ui-model-types';
import { UIUtilsContext } from '@lumahealthhq/ui-utils';
import MessageProvider from './MessageProvider';
import MixedContext from './MixedContext';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @ignore - internal component.
 */
export default function UIComponentsProvider(_ref) {
  let {
      children,
      // Mixed
      mixed,
      // Language
      messages,
      // UICore
      themeOptions,
      initializeMaterial,
      // Message
      onMessage,
      // UIUtilsContext
      logger,
      config,
      locale = ELocale.EnglishUS,
      setLocale,
      axiosClient
      // ModelProvider
    } = _ref,
    ModelProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const valueUtils = useMemo(() => ({
    logger,
    config,
    locale,
    setLocale,
    axiosClient
  }), [logger, config, locale, setLocale, axiosClient]);
  const valueMixed = useMemo(() => ({
    mixed
  }), [mixed]);
  return /*#__PURE__*/_jsx(UIUtilsContext.Provider, {
    value: valueUtils,
    children: /*#__PURE__*/_jsx(MixedContext.Provider, {
      value: valueMixed,
      children: /*#__PURE__*/_jsx(IntlProvider, {
        locale: locale,
        messages: messages,
        onError: () => {},
        children: /*#__PURE__*/_jsx(UICoreProvider, {
          initializeMaterial: initializeMaterial,
          themeOptions: themeOptions,
          children: /*#__PURE__*/_jsx(MessageProvider, {
            onMessage: onMessage,
            children: /*#__PURE__*/_jsx(ModelProvider, _extends({}, ModelProps, {
              children: children
            }))
          })
        })
      })
    })
  });
}